/**
 * @generated by @interxfi/j5-codegen (Plugin: NormalizedQueryPlugin) - do not edit */

import type { IxcSweepsClearingV1SweepParticipantStatsState } from '@interxfi/types';
import { schema } from 'normalizr';

export const IXC_SWEEPS_CLEARING_V1_SWEEP_PARTICIPANT_STATS_STATE_ENTITY_NAME = 'ixc.sweeps.clearing.v1.SweepParticipantStats';
export const ixcSweepsClearingV1SweepParticipantStatsStateEntity = new schema.Entity<IxcSweepsClearingV1SweepParticipantStatsState>(IXC_SWEEPS_CLEARING_V1_SWEEP_PARTICIPANT_STATS_STATE_ENTITY_NAME, {}, { idAttribute: (entity: IxcSweepsClearingV1SweepParticipantStatsState) => `${entity.accountId}-${entity.sweepTargetId}-${entity.firstDayOfMonth}` });

